import { useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { LanguageSwitcher } from '@/components/shared/LanguageSwitcher';

const HeaderSv = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm border-b border-gray-800">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/sv/" className="flex items-center space-x-3">
            <img
              src="/lovable-uploads/SSN_Logo_Horizontal_White.png"
              alt="Sweden Startup Nation"
              className="h-8"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-2">
            {/* Startups */}
            <Link to="/sv/startups">
              <button className="nav-link inline-flex h-10 w-max items-center justify-center rounded-md px-4 py-2 text-sm font-medium transition-colors focus:outline-none">
                Startups
              </button>
            </Link>

            {/* Scale-ups */}
            <Link to="/sv/scaleups">
              <button className="nav-link inline-flex h-10 w-max items-center justify-center rounded-md px-4 py-2 text-sm font-medium transition-colors focus:outline-none">
                Scale-ups
              </button>
            </Link>

            {/* Startup Journey */}
            <Link to="/sv/startup-journey">
              <button className="nav-link inline-flex h-10 w-max items-center justify-center rounded-md px-4 py-2 text-sm font-medium transition-colors focus:outline-none">
                Startup-resan
              </button>
            </Link>

            {/* Reports */}
            <div className="group relative">
              <Link to="/sv/reports">
                <button className="nav-link inline-flex h-10 w-max items-center justify-center rounded-md px-4 py-2 text-sm font-medium transition-colors focus:outline-none">
                  Rapporter
                </button>
              </Link>
            </div>

            {/* Insight Lab Main Menu */}
            <div className="group relative">
              <button className="nav-link inline-flex h-10 w-max items-center justify-center rounded-md px-4 py-2 text-sm font-medium transition-colors focus:outline-none">
                Insight Lab
                <ChevronDown className="ml-1 h-3 w-3" />
              </button>
              <div className="absolute left-0 top-full pt-1 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                <div className="w-auto min-w-40 bg-white border border-gray-200 shadow-xl rounded-md p-1 backdrop-blur-md">
                  <Link
                    to="/sv/insightlab/what-we-do"
                    className="nav-dropdown-link block px-2 py-1.5 text-sm transition-colors rounded-sm"
                  >
                    Vad vi gör
                  </Link>
                  <Link
                    to="/sv/insightlab/consultation"
                    className="nav-dropdown-link block px-2 py-1.5 text-sm transition-colors rounded-sm"
                  >
                    Rådgivning
                  </Link>
                  <Link
                    to="/sv/insightlab/research"
                    className="nav-dropdown-link block px-2 py-1.5 text-sm transition-colors rounded-sm"
                  >
                    Forskning
                  </Link>
                  <Link
                    to="/sv/insightlab/contribute"
                    className="nav-dropdown-link block px-2 py-1.5 text-sm transition-colors rounded-sm"
                  >
                    Bidra
                  </Link>
                  <Link
                    to="/sv/calendar"
                    className="nav-dropdown-link block px-2 py-1.5 text-sm transition-colors rounded-sm"
                  >
                    Kalender
                  </Link>
                </div>
              </div>
            </div>

            {/* Engage */}
            <div className="group relative">
              <button className="nav-link inline-flex h-10 w-max items-center justify-center rounded-md px-4 py-2 text-sm font-medium transition-colors focus:outline-none">
                Engagera
                <ChevronDown className="ml-1 h-3 w-3" />
              </button>
              <div className="absolute left-0 top-full pt-1 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                <div className="w-48 bg-white border border-gray-200 shadow-xl rounded-md p-1 backdrop-blur-md">
                  <Link
                    to="/sv/engage/startup"
                    className="nav-dropdown-link block px-2 py-1.5 text-sm transition-colors rounded-sm"
                  >
                    För Startups
                  </Link>
                  <Link
                    to="/sv/engage/data"
                    className="nav-dropdown-link block px-2 py-1.5 text-sm transition-colors rounded-sm"
                  >
                    För Datakontributörer
                  </Link>
                  <Link
                    to="/sv/engage/partner"
                    className="nav-dropdown-link block px-2 py-1.5 text-sm transition-colors rounded-sm"
                  >
                    För Partnerskap
                  </Link>
                </div>
              </div>
            </div>

            {/* About */}
            <div className="group relative">
              <button className="nav-link inline-flex h-10 w-max items-center justify-center rounded-md px-4 py-2 text-sm font-medium transition-colors focus:outline-none">
                Om oss
                <ChevronDown className="ml-1 h-3 w-3" />
              </button>
              <div className="absolute left-0 top-full pt-1 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                <div className="w-48 bg-white border border-gray-200 shadow-xl rounded-md p-1 backdrop-blur-md">
                  <Link
                    to="/sv/about"
                    className="nav-dropdown-link block px-2 py-1.5 text-sm transition-colors rounded-sm"
                  >
                    Om SSN
                  </Link>
                  <Link
                    to="/sv/newsroom"
                    className="nav-dropdown-link block px-2 py-1.5 text-sm transition-colors rounded-sm"
                  >
                    Nyheter & Press
                  </Link>
                  <Link
                    to="/sv/partners"
                    className="nav-dropdown-link block px-2 py-1.5 text-sm transition-colors rounded-sm"
                  >
                    Partners
                  </Link>
                </div>
              </div>
            </div>

            {/* Language Switcher - Desktop */}
            <div className="ml-4">
              <LanguageSwitcher />
            </div>
          </nav>

          {/* Desktop Actions - Mobile Language Switcher */}
          <div className="flex items-center gap-2 md:hidden">
            <LanguageSwitcher />
            {/* Mobile Menu Button */}
            <Button
              variant="ghost"
              size="icon"
              className="text-white hover:text-electric-cyan"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4">
            <div className="flex flex-col space-y-2 pt-4">
              <Link
                to="/sv/startup-journey"
                className="nav-mobile-link font-medium py-2 transition-colors duration-200"
                onClick={() => setIsMenuOpen(false)}
              >
                Startup-resan
              </Link>

              <Link
                to="/sv/reports"
                className="nav-mobile-link font-medium py-2 transition-colors duration-200"
                onClick={() => setIsMenuOpen(false)}
              >
                Rapporter
              </Link>

              {/* Insight Lab Mobile */}
              <div className="py-2">
                <div className="nav-mobile-link font-medium mb-2">Insight Lab</div>
                <div className="pl-4 space-y-1">
                  <Link
                    to="/sv/insightlab/what-we-do"
                    onClick={() => setIsMenuOpen(false)}
                    className="nav-mobile-link block text-sm py-1"
                  >
                    Vad vi gör
                  </Link>
                  <Link
                    to="/sv/insightlab/consultation"
                    onClick={() => setIsMenuOpen(false)}
                    className="nav-mobile-link block text-sm py-1"
                  >
                    Rådgivning
                  </Link>
                  <Link
                    to="/sv/insightlab/research"
                    onClick={() => setIsMenuOpen(false)}
                    className="nav-mobile-link block text-sm py-1"
                  >
                    Forskning
                  </Link>
                  <Link
                    to="/sv/insightlab/contribute"
                    onClick={() => setIsMenuOpen(false)}
                    className="nav-mobile-link block text-sm py-1"
                  >
                    Bidra
                  </Link>
                  <Link
                    to="/sv/calendar"
                    onClick={() => setIsMenuOpen(false)}
                    className="nav-mobile-link block text-sm py-1"
                  >
                    Kalender
                  </Link>
                </div>
              </div>

              {/* Startups Mobile */}
              <Link
                to="/sv/startups"
                className="nav-mobile-link font-medium py-2 transition-colors duration-200"
                onClick={() => setIsMenuOpen(false)}
              >
                Startups
              </Link>

              {/* Scale-ups Mobile */}
              <Link
                to="/sv/scaleups"
                className="nav-mobile-link font-medium py-2 transition-colors duration-200"
                onClick={() => setIsMenuOpen(false)}
              >
                Scale-ups
              </Link>

              {/* Engage Mobile */}
              <div className="py-2">
                <div className="nav-mobile-link font-medium mb-2">Engagera</div>
                <div className="pl-4 space-y-1">
                  <Link
                    to="/sv/engage/startup"
                    onClick={() => setIsMenuOpen(false)}
                    className="nav-mobile-link block text-sm py-1"
                  >
                    För Startups
                  </Link>
                  <Link
                    to="/sv/engage/data"
                    onClick={() => setIsMenuOpen(false)}
                    className="nav-mobile-link block text-sm py-1"
                  >
                    För Datakontributörer
                  </Link>
                  <Link
                    to="/sv/engage/partner"
                    onClick={() => setIsMenuOpen(false)}
                    className="nav-mobile-link block text-sm py-1"
                  >
                    För Partnerskap
                  </Link>
                </div>
              </div>

              {/* About Mobile */}
              <div className="py-2">
                <div className="nav-mobile-link font-medium mb-2">Om oss</div>
                <div className="pl-4 space-y-1">
                  <Link
                    to="/sv/about"
                    onClick={() => setIsMenuOpen(false)}
                    className="nav-mobile-link block text-sm py-1"
                  >
                    Om SSN
                  </Link>
                  <Link
                    to="/sv/newsroom"
                    onClick={() => setIsMenuOpen(false)}
                    className="nav-mobile-link block text-sm py-1"
                  >
                    Nyheter & Press
                  </Link>
                  <Link
                    to="/sv/partners"
                    onClick={() => setIsMenuOpen(false)}
                    className="nav-mobile-link block text-sm py-1"
                  >
                    Partners
                  </Link>
                </div>
              </div>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export { HeaderSv };
export default HeaderSv;
